<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="demo-basic-card">
        <div class="vx-row">

            <div v-for="card in cards" :key="card.name" class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
                <vx-card>
                    <img :src="card.img" alt="content-img" class="responsive rounded-lg">
                    <div class="my-6">
                        <h5 class="mb-2">{{ card.name }}</h5>
                        <p class="text-grey">{{ card.pdetails }}</p>
                    </div>
                    <vs-divider></vs-divider>
                    <div class="flex justify-between flex-wrap">
                        <span>

                        </span>
                        <span>
                            <p class="text-xl">{{card.utext}}</p>
                            <p class="text-grey">{{card.btext}}</p>
                        </span>
                    </div>
                </vx-card>
            </div>

        </div>

    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'



export default{
    components: {
        VuePerfectScrollbar,

    },
    data() {
        return {
            cards:[
                {name:'Welcome',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img1.jpg')},
                {name:'Mr.Chaiya',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img2.jpg')},
                {name:'Mr.Toh',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img3.jpg')},
                {name:'Mr.Sukij',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img4.jpg')},
                {name:'Khun Nate',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img5.jpg')},
                {name:'HomePro',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img6.jpg')},
                {name:'Team',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img7.jpg')},
                {name:'Cronos',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img8.jpg')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img9.jpg')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img10.jpg')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img11.jpg')},
                {name:'ICC',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img12.jpg')},
                {name:'ICC',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img13.jpg')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img14.jpg')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img15.jpg')},
                {name:'Project',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img16.jpg')},
                {name:'Project',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img17.png')},
                {name:'Project',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img18.png')},
                {name:'Machine',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img19.png')},
                {name:'Machine',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img20.png')},
                {name:'Machine',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img21.png')},
                {name:'Machine',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img23.png')},
                {name:'Boat',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img22.png')},
                {name:'Boat',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img24.png')},
                {name:'Boat',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img25.png')},
                {name:'Boat',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img26.png')},
                {name:'Project',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img27.png')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img28.png')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img29.png')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img30.png')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img31.png')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img32.png')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img33.png')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img34.png')},
                {name:'Dohome',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img35.png')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img36.png')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img37.png')},
                {name:'Seminar',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img38.png')},
                {name:'Donation',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img39.jpg')},
                {name:'Donation',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img40.jpg')},
                {name:'Donation',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img41.jpg')},
                {name:'Donation',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img42.jpg')},
                {name:'Donation',pdetail:'More Information',utext:'',btext:'Image',img:require('@/assets/images/portfolio/img43.jpg')},

            ],
        }
    },
    computed: {
      scrollbarTag() { return this.$store.getters.scrollbarTag },
    },
    mounted() {

    },
    created() {

    }
}
</script>

<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
}
</style>
